import config from '../configs/config.json';

export default function loadImage({ imageCode }) {
  imageCode = imageCode && imageCode.indexOf('.png') >= 0? imageCode.replace('.png', ''): imageCode;
  return `${config.nodejs.server}/images/${imageCode}`;
}